const routes = [
  {
    path: '/crm',
    name: 'CrmPage',
    auth: true,
    authPage: 'LoginPage',
    loaders: {
      page: () => import('./containers/CrmPage/CrmPage'),
    },
  },
  {
    path: '/crm/customers/:customerId',
    name: 'CrmCustomerPage',
    auth: true,
    authPage: 'LoginPage',
    loaders: {
      page: () => import('./containers/CrmCustomerPage/CrmCustomerPage'),
    },
  },
];

export default routes;
